import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoutes = () => {
    const decodedEmail = localStorage.getItem("reg-site");
    return decodedEmail ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;